import type { FishStats } from './fish'
import type { PlacedDecoration } from './decorations'

export interface SaveData {
  version: string
  createdAt: string
  updatedAt: string
  economy: {
    coins: number
    lastLoginReward: string
  }
  player: {
    level: number
    xp: number
    needed: number
  }
  fish: Record<string, FishStats & { unlocked: boolean }>
  water: number
  lighting: 'day' | 'night'
  placedDecorations: PlacedDecoration[]
  purchasedDecorations: string[]
  cleanCount: number
  ambientSoundId: 'none' | 'river' | 'forest' | 'gentle'
  settings: {
    soundEnabled: boolean
    autoSaveEnabled: boolean
    saveInterval: number
  }
}

export const SAVE_VERSION = '1.0.0'

export const DEFAULT_SETTINGS: SaveData['settings'] = {
  soundEnabled: false,
  autoSaveEnabled: true,
  saveInterval: 30,
}

export function createEmptySaveData(): SaveData {
  return {
    version: SAVE_VERSION,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    economy: {
      coins: 100,
      lastLoginReward: '',
    },
    player: {
      level: 1,
      xp: 0,
      needed: 100,
    },
    fish: {},
    water: 1000,
    lighting: 'day',
    placedDecorations: [],
    purchasedDecorations: [],
    cleanCount: 0,
    ambientSoundId: 'none',
    settings: { ...DEFAULT_SETTINGS },
  }
}